import { render, staticRenderFns } from "./custom_skill.vue?vue&type=template&id=8c7e3ff4&scoped=true&lang=pug&"
import script from "./custom_skill.vue?vue&type=script&lang=coffee&"
export * from "./custom_skill.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c7e3ff4",
  null
  
)

export default component.exports